import { useContext, useMemo, type DependencyList } from 'react'
import { ResponsiveContext } from './ResponsiveContext'
import type { ResponsiveCtx } from './types'

export const useResponsiveMemo = <T>(
	factory: (ctx: ResponsiveCtx) => T,
	deps: DependencyList = [],
) => {
	const ctx = useContext(ResponsiveContext)
	const depsMemo = useMemo(() => deps, deps)

	return useMemo(() => factory(ctx), [ctx, depsMemo])
}
